/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React from 'react';
import styles from 'components/FormTable/FormTable.scss';

const MONTH_IN_MS = 1000 * 60 * 60 * 24 * 30;

let Row = ({
  title,
  notes = [],
  color = 'blue',
  onDelete,
  keyWidth,
  production,
}) => {

  if(production !== undefined) {
    notes.push({key: 'is production', value: production ? 'YES' : 'NO'});
  }

  return (
    <div className={styles.row}>
      <div className={styles.header}>
        <span className={[styles.indicator, styles[color]].join(' ')} />
        <span className={styles.title}>{title}</span>
        {typeof onDelete === 'function' ? <a href='javascript:;' role='button' className={styles.del} onClick={onDelete}>&times;</a> : null}
      </div>
      {notes.map(({ key, keyColor = '', value, strong }, index) => {
        return (
          <div key={index.toString()} className={styles.info}>
            <span style={{width: keyWidth}} className={[styles.label, styles[keyColor]].join(' ')}>{key}</span>
            {strong ? <strong>{value}</strong> : <span className={styles.din}>{value}</span>}
          </div>
        );
      })}
    </div>
  );
};

let FormTable = ({ items, keyWidth = '100px' }) => (
  <div className={styles.table}>
    {items.map((item, index) => {
      return <Row key={index.toString()} keyWidth={keyWidth} {...item} />
    })
    }
  </div>
);

FormTable.propTypes = {
  items: PropTypes.array.isRequired,
  keyWidth: PropTypes.string,
};

export default FormTable;
